    import { useLocation } from "react-router-dom";
    import { MapPin, Phone, Mail } from "lucide-react";

    export default function PurohitDetails() {
    const { state } = useLocation();
    if (!state) {
  return <p className="text-center mt-20">No data found</p>;
}
    const { purohit, paid } = state;

    return (
        <div className="w-full min-h-screen bg-[#fffdf7] pt-20 px-4 flex justify-center">
        <div className="max-w-2xl w-full bg-white shadow-xl rounded-2xl p-6 border">

            <h2 className="text-2xl font-bold mb-4">Purohit Profile</h2>

            {/* Basic Card */}
            <div className="flex gap-4 items-start">
            <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-orange-400 to-red-500"></div>

            <div>
                <h3 className="text-xl font-semibold">{purohit.name}</h3>

                <p className="flex items-center gap-1 text-gray-700 mt-1">
                <MapPin size={16} /> {purohit.city}
                </p>

                <p className="text-gray-600 mt-1">{purohit.experience}</p>
            </div>
            </div>

            <h4 className="mt-6 font-semibold">Contact Details</h4>

            {paid ? (
            <>
                <div className="bg-orange-50 border p-3 rounded-lg flex items-center gap-3">
                <Phone size={18} className="text-orange-600" /> {purohit.phone}
                </div>

                <div className="bg-orange-50 border p-3 rounded-lg flex items-center gap-3 mt-3">
                <Mail size={18} className="text-orange-600" /> {purohit.email}
                </div>
            </>
            ) : (
            <p className="text-red-500 mt-3">Payment not completed.</p>
            )}
        </div>
        </div>
    );
    }
